<div class="container contactus padding0">
  <h2>Contact Us</h2>

  <h4>UNDERWRITING CONTACTS</h4>

  <h3>
    General Liability, Remodeling General Liability, Non-Admitted Excess
    Liability, Contractors Personal Property,<br />
    Excess Liability, Builders Risk, and Contractors Equipment.
  </h3>

  <p>2108 Harvard Street, Suite 260</p>
  <p>Sacramento, California 95815</p>
  <p>Main (916) 587-1640</p>
  <p>Toll Free (855) 733-9500</p>
  <p>Facsimile (916) 848-3789</p>
  <p>Email ArtisanEdgeHelp@tmhcc.com</p>

  <!-- <h3>Contractors Environmental Liability</h3>
  <p>One Bala Plaza, Suite 100</p>
  <p>Bala Cynwyd, PA 19004</p>
  <p>Toll Free (888) 451-9836</p>
  <p>Email CECHelp@tmsic.com</p> -->

  <h3>Contractors Professional Liability</h3>
  <p>2300 Clayton Road, Suite 1100</p>
  <p>Concord, CA 94520</p>
  <p>Phone (925) 685-1600</p>
  <p>Email ContractorsProfessionalHelp@tmhcc.com</p>
  <h4>BILLING CONTACTS</h4>
  <h3>Premium Finance</h3>
  <p>Toll Free (888) 875-4000</p>
  <h3>Installment Billing</h3>
  <p>Toll Free (888) 313-4434</p>
  <h3>Agency Billing</h3>
  <p>Phone (713) 996-1216</p>
  <h4>CLAIMS CONTACTS</h4> 
  <p [innerHTML]="claimsContactInfo"></p>
  
</div>
